export default __webpack_public_path__ + "static/media/new-more-icon.960266cb.svg";